/* Mawlaii Product page — interactivity (progressive enhancement) */
(function () {
  'use strict';

  // ----- Accordion toggle -----
  document.querySelectorAll('.mp__acc-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.mp__acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      item.classList.toggle('is-closed', isOpen);
    });
  });

  // ----- Variant chip toggle + hidden select sync -----
  var form = document.getElementById('ProductForm');
  var hiddenSelect = document.getElementById('VariantSelect');

  function getSelectedOptions() {
    var groups = document.querySelectorAll('.mp__variant-chips');
    var selected = [];
    groups.forEach(function (group) {
      var active = group.querySelector('.mp__variant-chip.is-selected');
      if (active) selected.push(active.getAttribute('data-value'));
    });
    return selected;
  }

  function syncVariant() {
    if (!hiddenSelect) return;
    var selected = getSelectedOptions();
    var matchKey = selected.join('|');
    var options = hiddenSelect.querySelectorAll('option');
    options.forEach(function (opt) {
      if (opt.getAttribute('data-options') === matchKey) {
        hiddenSelect.value = opt.value;
        var idInput = form && form.querySelector('input[name="id"]');
        if (idInput) idInput.value = opt.value;
      }
    });
  }

  document.querySelectorAll('.mp__variant-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('.mp__variant-chip');
      if (!chip || chip.disabled) return;
      group.querySelectorAll('.mp__variant-chip').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      chip.classList.add('is-selected');

      // Update the "selected value" label small text
      var label = group.parentElement && group.parentElement.querySelector('[data-mp-selected-value]');
      if (label) label.textContent = chip.getAttribute('data-value');

      syncVariant();
    });
  });

  // ----- Quantity stepper -----
  document.querySelectorAll('.mp__qty').forEach(function (qty) {
    var input = qty.querySelector('.mp__qty-input');
    var minus = qty.querySelector('[data-mp-qty-minus]');
    var plus = qty.querySelector('[data-mp-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ----- Thumbnail gallery swap -----
  var mainImg = document.getElementById('mp-gallery-main-img');
  document.querySelectorAll('.mp__gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-full');
      if (!mainImg || !fullSrc) return;
      document.querySelectorAll('.mp__gallery-thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      mainImg.src = fullSrc;
      mainImg.removeAttribute('srcset');
    });
  });

  // ----- Share button -----
  document.querySelectorAll('[data-mp-share]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var url = window.location.href;
      var title = document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          link.textContent = 'Link copied';
          setTimeout(function () { link.textContent = 'Share'; }, 2000);
        });
      }
    });
  });
})();
